import config from '../../config';

export default {
  url: `${config.api.baseURL}/reset-pin`,
  options: {
    method: 'POST'
  },
  transformer(data) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/api/pin/reset.js